// extracted by mini-css-extract-plugin
export default {"mCard":"ZD-z","image":"_D-z","imageNoBackground":"aE-z","imageHasCategory":"bE-z","fullWidth":"cE-z"};